import React from "react";

// Generic shimmer skeleton for the data tabs (Total Queries / User Sentiment / Incidents).
// Mirrors their shared shape — a section head, a chart card, and a table card — so the real
// content drops in without a layout jump and no mock data flashes first. Purely presentational.
const TabSkeleton: React.FC = () => (
    <div aria-busy="true">
        <div className="po-section-head">
            <div style={{ flex: 1 }}>
                <span className="po-skel po-skel--value" style={{ width: "38%" }} />
                <span className="po-skel po-skel--line" style={{ width: "60%" }} />
            </div>
        </div>

        <div className="po-card po-chart-card po-skel-card" aria-hidden="true">
            <span className="po-skel po-skel--label" />
            <div className="po-skel-bars">
                {Array.from({ length: 6 }).map((_, i) => (
                    <span className="po-skel po-skel--bar" key={i} style={{ width: `${92 - i * 12}%` }} />
                ))}
            </div>
        </div>

        <div className="po-card po-table-card po-skel-card" aria-hidden="true">
            <span className="po-skel po-skel--label" />
            <div className="po-skel-bars">
                {Array.from({ length: 5 }).map((_, i) => (
                    <span className="po-skel po-skel--bar" key={i} style={{ width: "100%" }} />
                ))}
            </div>
        </div>
    </div>
);

export default TabSkeleton;
